import { hasConsensusOddsIndication } from "./fixtureMarketOdds";
import { canOracleFixture } from "./oracle";
import { asOracleFixture } from "./adminLeague";
export function workspaceIndications({
  row,
  outcomes,
  models,
  quotes,
  threshold,
  loading = false,
  now = Date.now(),
  prematchContext = null,
  market = null,
  line = null,
}) {
  if (loading) return { state: "loading", matches: [] };
  if (!canOracleFixture(asOracleFixture(row, row.league), now) && !prematchContext?.historical)
    return { state: "ineligible", matches: [] };
  const stored=prematchContext?.stored_indications;
  if(prematchContext?.historical && Array.isArray(stored)) {
    const matches=stored.filter(x=>x.market===market && (line==null ? x.line==null : Number(x.line)===Number(line)))
      .filter(x=>outcomes.includes(x.side??x.selection))
      .map(x=>({...x,side:x.side??x.selection,model:x.model??'result',basis:x.basis??'highest',fair:x.fair??x.fairOdd,quote:x.quote??x.marketOdd}));
    return {state:matches.length?'indication':'none',matches,stored:true};
  }
  if (
    threshold == null ||
    threshold === "" ||
    !Number.isFinite(Number(threshold))
  )
    return { state: "missing", matches: [] };
  if (prematchContext?.historical && !prematchContext.records?.length) return {state:"missing",matches:[]};
  const matches = [];
  let missing = false;
  const result = models.result;
  const statistic = models.statistic ?? models.statistics;
  for (const [basis, prices] of Object.entries(quotes))
    outcomes.forEach((side, i) => {
      const fair = result?.[i], statFair = statistic?.[i], quote = prices[i];
      if (!(Number(fair) > 0) || !(Number(statFair) > 0) || !(Number(quote) > 0)) {
        missing = true;
        return;
      }
      if (hasConsensusOddsIndication(fair, statFair, quote, threshold)) {
        matches.push({model:"result",basis,side,fair:Number(fair),quote:Number(quote)},
          {model:"statistic",basis,side,fair:Number(statFair),quote:Number(quote)});
      }
    });
  return {
    state: matches.length ? "indication" : missing ? "missing" : "none",
    matches,
    incomplete: missing,
  };
}
